<template>
  <span class="inline-flex w-fit items-center gap-1 rounded-full bg-black/60 px-2.5 py-1 text-xs leading-none text-white backdrop-blur-sm">
    <Icon name="tabler:eye-check" class="size-3.5" aria-hidden="true" />
    Просмотрено
  </span>
</template>
